// "Keep The Infinite Free": a tip with Stripe (a Payment Link, opened on Stripe's site), in SOL or
// in ETH to the wallet addresses (copy one, or open it in a wallet app).
import { useState } from "react";
import { ETHEREUM_ADDRESS, SOLANA_ADDRESS, STRIPE_TIP_URL } from "../support";
import { Link } from "../lib/router";
import { Modal } from "./Modal";

function Wallet({
  id,
  title,
  hint,
  address,
  uri,
}: {
  id: string;
  title: string;
  hint: string;
  address: string;
  uri: string;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <section className="panel stack support-option" aria-labelledby={`tip-${id}-h`}>
      <h3 id={`tip-${id}-h`}>{title}</h3>
      <p className="muted small">{hint}</p>
      <code className="support-address" data-testid={`tip-${id}-address`}>
        {address}
      </code>
      <div className="row">
        <button
          type="button"
          className="btn"
          onClick={() =>
            void navigator.clipboard
              ?.writeText(address)
              .then(() => setCopied(true))
              .catch(() => undefined)
          }
          data-testid={`tip-${id}-copy`}
        >
          {copied ? "Copied ✓" : "Copy address"}
        </button>
        <a className="btn btn-ghost" href={uri}>
          Open in wallet
        </a>
      </div>
    </section>
  );
}

export function SupportDialog({ onClose }: { onClose: () => void }) {
  return (
    <Modal title="Keep The Infinite Free" onClose={onClose}>
      <div className="stack support-dialog" data-testid="support-dialog">
        <p>
          The Infinite has no ads, no tracking and no paywall, and it never stops playing. If you enjoy it, a tip helps
          pay for the server and keeps it that way.
        </p>
        {STRIPE_TIP_URL && (
          <section className="panel stack support-option" aria-labelledby="tip-stripe-h">
            <h3 id="tip-stripe-h">Card, Apple Pay or Google Pay</h3>
            <p className="muted small">Choose any amount. You pay on Stripe's secure page; we never see your card.</p>
            <a
              className="btn btn-primary"
              href={STRIPE_TIP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="tip-stripe"
            >
              Leave a tip with Stripe
            </a>
          </section>
        )}
        {SOLANA_ADDRESS && (
          <Wallet
            id="solana"
            title="Solana"
            hint="Send SOL to this address. Transfers are public on the blockchain."
            address={SOLANA_ADDRESS}
            uri={`solana:${SOLANA_ADDRESS}`}
          />
        )}
        {ETHEREUM_ADDRESS && (
          <Wallet
            id="ethereum"
            title="Ethereum"
            hint="Send ETH on Ethereum mainnet to this address — not from another network. Transfers are public on the blockchain."
            address={ETHEREUM_ADDRESS}
            uri={`ethereum:${ETHEREUM_ADDRESS}`}
          />
        )}
        <p className="muted small">
          Tips are a thank-you, not a donation in the tax sense, and don't buy anything on the site. See the{" "}
          <Link href="/legal/privacy#tips">Privacy Policy</Link> for what happens with payment data.
        </p>
      </div>
    </Modal>
  );
}
